var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4285F4;}\n\t.st1{fill:#34A853;}\n\t.st2{fill:#FBBC05;}\n\t.st3{fill:#EA4335;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,8.2c0-0.6-0.1-1.1-0.1-1.6H8v3.1h4.3c-0.2,1-0.7,1.8-1.6,2.4v2h2.6C14.8,12.7,15.7,10.6,15.7,8.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,16c2.2,0,4-0.7,5.3-1.9l-2.6-2C10,12.5,9.1,12.8,8,12.8c-2.1,0-3.8-1.4-4.5-3.3H0.9v2.1 C2.2,14.2,4.9,16,8,16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.5,9.5C3.4,9,3.3,8.5,3.3,8s0.1-1,0.3-1.5V4.4H0.9C0.3,5.5,0,6.8,0,8c0,1.3,0.3,2.5,0.9,3.6 C0.9,11.6,3.5,9.5,3.5,9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8,3.2c1.2,0,2.2,0.4,3.1,1.2l2.3-2.3C12,0.8,10.2,0,8,0C4.9,0,2.2,1.8,0.9,4.4l2.7,2.1C4.2,4.6,5.9,3.2,8,3.2z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,0h16v16H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle16);
export default __webpack_public_path__ + "static/media/google-16.2ba5489a817b557458b504673ae05975.svg";
export { ForwardRef as ReactComponent };